import React, { useState } from "react";
import "../styles/login.css";
import logo from "../../src/assets/all-images/logo.png";
import constructionBg from "../../src/assets/all-images/matchine-img/wheel-loader.jpeg";
import { useTranslation } from "../hooks/useTranslation";

const Login = () => {
  const t = useTranslation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    // Create the data object
    const data = {
      email: email,
      password: password,
    };

    try {
      const response = await fetch("https://techcrew.pk/ulc/login.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams(data),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const responseData = await response.json();

      if (responseData.status?.code === 200) {
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("user", JSON.stringify(responseData.data));
        const userRole = responseData.data.user.role_display; // 'Admin', 'Supplier', or 'Renter'
        // console.log(`/${userRole}Dashboard`, responseData.data);
        // 4. Redirect to appropriate dashboard
        window.location.href = `/${userRole}Dashboard`;
      } else {
        setError(responseData.status?.message || t("login.error"));
      }
    } catch (err) {
      setError(t("login.network_error"));
      console.error("Login error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <div className="login-content">
          <img src={logo} alt="Company Logo" className="login-logo " />
          {/* <h1>{t("login.welcome")}</h1> */}
          <p>{t("login.tagline")}</p>

          <div className="feature-highlight">
            <div className="feature-badge">
              <span className="feature-icon">🏗️</span>
              <span>{t("login.feature1")}</span>
            </div>
            <div className="feature-badge">
              <span className="feature-icon">🚜</span>
              <span>{t("login.feature2")}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="login-right">
        <div className="login-card">
          <div className="card-header">
            <h2>{t("login.sign_in")}</h2>
            <p>{t("login.access_portal")}</p>
          </div>

          <form onSubmit={handleSubmit}>
            {error && <div className="error-message">{error}</div>}

            <div className="input-group">
              <label>{t("login.email")}</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t("login.email_placeholder")}
                required
              />
            </div>

            <div className="input-group">
              <label>{t("login.password")}</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder={t("login.password_placeholder")}
                required
              />
              <a href="/forgot-password" className="forgot-link">
                {t("login.forgot_password")}
              </a>
            </div>

            <button type="submit" className="submit-btn" disabled={isLoading}>
              {isLoading ? t("login.signing_in") : t("login.sign_in")}
            </button>
          </form>

          <div className="card-footer">
            {t("login.no_account")}{" "}
            <a href="/register">{t("login.contact_admin")}</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
